module.exports = __webpack_public_path__ + "static/img/AR.7ac2cc8a.png";